import { Recurrence } from '@tableau/self-service-schedules';
import { call, put } from 'redux-saga/effects';
import _ from 'underscore';

import { SessionSiteSelectors } from '~selectors/SessionInfoSelectors';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { getAppStore } from '../../app/AppStore';
import { RefreshSelfServiceScheduleDialog } from '../../app/content/RefreshSelfServiceScheduleDialog';
import { Messages } from '../../codegen/Localize';
import { DefinedBy } from '../../schedule/types/ISchedule';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { Set } from '../../ts/models/Set';
import { RefreshTargetType, RefreshTaskType } from '../../ts/ServerApi/requests/CreateSelfServiceScheduleExtractTasksRequest';
import { ExtractTaskType } from '../../ts/ServerApi/types/IExtractTask';
import { ChangeScheduleActionService } from '../../ts/services/ChangeScheduleAction';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { ChangeExtractRefreshScheduleAction } from '../actions/ChangeExtractRefreshScheduleAction';
import { CreateExtractRefreshAction } from '../actions/CreateExtractRefreshAction';


export type RefreshSSSDialogMode = 'SSS' | 'Legacy' | 'Mixed';
export function decideWhichDialogToShow(tasks: IExtractTaskInfo[]): RefreshSSSDialogMode {
  const spaceInfo = selectSpaceInfo(getAppStore().getState());
  const isServerTasksPage = spaceInfo.spaceType === 'servertasks';
  // If we're not on the server tasks page then we can just get the FF status for the current site
  if (!isServerTasksPage) {
    const isExtractSSSEnabledForServer = FeatureFlags.selfServiceSchedulesForRefreshEnabled;
    const isExtractSSSEnabledForSite = SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
    return isExtractSSSEnabledForServer && isExtractSSSEnabledForSite
      ? 'SSS'
      : 'Legacy';
  }
  // If we ARE on the server tasks page we just open the dialog for whatever type the refreshes are, or fail entirely (Mixed)
  const allSSS = _.all(tasks, (task => task.schedule.definedBy === DefinedBy.SELF_SERVICE));
  const allLegacy = _.all(tasks, (task => task.schedule.definedBy !== DefinedBy.SELF_SERVICE));
  if (allSSS) {
    return 'SSS';
  }
  if (allLegacy) {
    return 'Legacy';
  }
  return 'Mixed';
}

export function* handleChangeExtractRefreshScheduleAction(action: ChangeExtractRefreshScheduleAction) {
  try {
    switch(decideWhichDialogToShow(action.tasks)) {
      case 'SSS':
        yield call(changeExtractRefreshSSSAction, action.tasks);
        break;
      case 'Legacy':
        yield call(executeChangeExtractRefreshScheduleAction, action.tasks);
        break;
      case 'Mixed':
        ToasterService.getInstance().pop({
          type: ToastType.Error,
          text: Messages.refreshSelfServiceScheduleEditMixedError(),
        });
        return; // No need to get space contents if we don't change anything
    }
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeChangeExtractRefreshScheduleAction(items: IExtractTaskInfo[]) {
  return ChangeScheduleActionService.forExtractTasks(Set.fromIdItemArray(items));
}

export function changeExtractRefreshSSSAction(items: IExtractTaskInfo[]) {
  const allSameType = _.unique(items.map(item => item.type)).length === 1;

  // Task Type
  const isIncremental = items.map(item => item.type === ExtractTaskType.IncrementExtract);
  const allowIncremental = _.all(isIncremental);
  const ids = items.map(item => Number(item.id));
  const save = (recurrence: Recurrence, taskType: RefreshTaskType, scheduleName: string) => CreateExtractRefreshAction.sendCreateExtractRequest(recurrence, taskType, scheduleName, ids);
  const targetType: RefreshTargetType = allSameType
    ? items[0].type as RefreshTargetType
    : 'Mixed';
  return RefreshSelfServiceScheduleDialog.open({
    save,
    quantity: items.length,
    targetType,
    taskType: allowIncremental ? 'IncrementExtract' : 'RefreshExtract',
    disableSelectingTaskType: !allowIncremental,
  });
}
